import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { getNestedTranslation } from '@colonist/i18n';
import { ArrayUtils } from '@colonist/utils';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UIDeviceController } from '../ui_html/UIDeviceController.ts';
const CLASSIC_4P_MATCH_TYPES = new Set([
    MatchmakingMatchTypes.RankedClassic4P,
    MatchmakingMatchTypes.UnrankedClassic4P
]);
const ONE_V_ONE_MATCH_TYPES = new Set([
    MatchmakingMatchTypes.UnrankedClassic1v1,
    MatchmakingMatchTypes.RankedClassic1v1
]);
const RUSH_MATCH_TYPES = new Set([
    MatchmakingMatchTypes.RankedRush4P
]);
const MATCHMAKING_TIPS = [
    {
        key: 'strings:homePage.matchmakingTips.tryRushHighestRated',
        excludedMatchTypes: RUSH_MATCH_TYPES,
        requiresNeverPlayedRush: true
    },
    {
        key: 'strings:homePage.matchmakingTips.tryRushTenMinutes',
        matchTypes: CLASSIC_4P_MATCH_TYPES,
        requiresNeverPlayedRush: true
    },
    {
        key: 'strings:homePage.matchmakingTips.diversifyResources'
    },
    {
        key: 'strings:homePage.matchmakingTips.watchReplays'
    },
    {
        key: 'strings:homePage.matchmakingTips.watchYoutubers'
    },
    {
        key: 'strings:homePage.matchmakingTips.placementEngine'
    },
    {
        key: 'strings:homePage.matchmakingTips.placementDenial'
    },
    {
        key: 'strings:homePage.matchmakingTips.assumeLeaderVictoryPoint'
    },
    {
        key: 'strings:homePage.matchmakingTips.bankTrades',
        excludedMatchTypes: ONE_V_ONE_MATCH_TYPES
    },
    {
        key: 'strings:homePage.matchmakingTips.blockResources',
        matchTypes: ONE_V_ONE_MATCH_TYPES
    },
    {
        key: 'strings:homePage.matchmakingTips.oneVsOneTempo',
        matchTypes: ONE_V_ONE_MATCH_TYPES
    },
    {
        key: 'strings:homePage.matchmakingTips.planThreeBuilds'
    },
    {
        key: 'strings:homePage.matchmakingTips.rushDecisionSpeed'
    },
    {
        key: 'strings:homePage.matchmakingTips.continueOnMobile',
        requiresNotOnNativeMobileApp: true
    },
    {
        key: 'strings:homePage.matchmakingTips.playWithFriends'
    },
    {
        key: 'strings:homePage.matchmakingTips.beNiceMakeFriends'
    }
];
export function getRandomMatchmakingTip(matchType) {
    const eligibleTips = MATCHMAKING_TIPS.filter((tip)=>isTipEligible(tip, matchType));
    if (eligibleTips.length == 0) return undefined;
    const tipKey = ArrayUtils.randomElementFromArray(eligibleTips).key;
    return getNestedTranslation({
        key: 'strings:homePage.matchmakingTips.prefix'
    }, {
        tip: {
            key: tipKey
        }
    });
}
function isTipEligible(tip, matchType) {
    if (tip.matchTypes != undefined && !tip.matchTypes.has(matchType)) return false;
    if (tip.excludedMatchTypes != undefined && tip.excludedMatchTypes.has(matchType)) return false;
    if (tip.requiresNeverPlayedRush && hasPlayedRush()) return false;
    if (tip.requiresNotOnNativeMobileApp && isOnNativeMobileApp()) return false;
    return true;
}
function hasPlayedRush() {
    return StorageWrapper.getRushGamesPlayed() > 0;
}
function isOnNativeMobileApp() {
    return UIDeviceController.isUserOnIOSApp() || UIDeviceController.isUserOnAndroidApp();
}
